const RANKING_ITEMS = [
  { rank: 1, title: '狂飙', type: '电视剧', hot: '9.8', tags: ['犯罪', '剧情'], desc: '年度现象级扫黑大剧，张译张颂文飙戏', trend: 'up' },
  { rank: 2, title: '满江红', type: '电影', hot: '9.5', tags: ['悬疑', '喜剧'], desc: '沈腾易烊千玺联袂，张艺谋执导力作', trend: 'same' },
  { rank: 3, title: '三体', type: '电视剧', hot: '9.3', tags: ['科幻', '悬疑'], desc: '刘慈欣科幻巨著改编，视觉震撼', trend: 'up' },
  { rank: 4, title: '流浪地球2', type: '电影', hot: '9.4', tags: ['科幻', '灾难'], desc: '国产科幻巅峰续作，吴京刘德华主演', trend: 'up' },
  { rank: 5, title: '繁花', type: '电视剧', hot: '9.2', tags: ['剧情', '年代'], desc: '王家卫首部剧集，胡歌演绎上海传奇', trend: 'down' },
  { rank: 6, title: '长空之王', type: '电影', hot: '9.1', tags: ['动作', '剧情'], desc: '王一博胡军领衔，试飞员热血故事', trend: 'up' },
  { rank: 7, title: '鬼灭之刃', type: '动漫', hot: '9.6', tags: ['热血', '战斗'], desc: '锻刀村篇震撼开播，制作水准拉满', trend: 'same' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 bg-primary-100/70 text-primary-700 text-xs font-medium px-3 py-1 rounded-full mb-3">
            <i className="ri-fire-line" />
            <span>实时热度</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">热播榜单</h2>
          <p className="text-sm text-foreground-500 mt-2">全网热门影视实时排行，追剧看片不迷路</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {RANKING_ITEMS.map((item) => (
            <div
              key={item.rank}
              className="bg-background-100 rounded-xl p-4 flex items-start gap-4 hover:bg-background-200/70 transition-colors cursor-pointer group"
              data-product-shop=""
            >
              <div className="shrink-0 w-10 h-10 rounded-lg bg-background-200 flex items-center justify-center">
                <span className={`text-lg font-bold font-heading ${
                  item.rank <= 3 ? 'text-primary-500' : 'text-foreground-500'
                }`}>
                  {item.rank}
                </span>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-sm font-semibold text-foreground-950 truncate group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                  <span className="shrink-0 text-[10px] px-1.5 py-0.5 rounded bg-background-200 text-foreground-500 font-medium">
                    {item.type}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 line-clamp-1 mb-2">{item.desc}</p>
                <div className="flex items-center gap-2">
                  <div className="flex items-center gap-1">
                    <i className="ri-star-fill text-amber-400 text-xs" />
                    <span className="text-xs font-semibold text-foreground-700">{item.hot}</span>
                  </div>
                  <div className="flex gap-1">
                    {item.tags.map((tag) => (
                      <span key={tag} className="text-[10px] text-foreground-400 bg-background-200/80 px-1.5 py-0.5 rounded">
                        {tag}
                      </span>
                    ))}
                  </div>
                  {item.trend === 'up' && <i className="ri-arrow-up-line text-green-500 text-xs" />}
                  {item.trend === 'down' && <i className="ri-arrow-down-line text-red-400 text-xs" />}
                  {item.trend === 'same' && <i className="ri-subtract-line text-foreground-400 text-xs" />}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}